function pitchStoryDialogCtrl(
  $uibModalInstance,
  $translate,
  type,
  storyId,
  platforms,
  sites,
  platformSites,
  excludedDestinations
) {
  this.type = type;
  this.storyId = storyId;
  this.platforms = platforms;
  this.sites = type === 'publications' ? sites : platformSites;
  this.excludedDestinations = excludedDestinations;
  this.aria_closeLabel = $translate.instant('CLOSE_V');

  this.success = (pitchData) => {
    $uibModalInstance.close(pitchData.data);
  };
}

const pitchStoryDialogCtrlArr = [
  '$uibModalInstance',
  '$translate',
  'type',
  'storyId',
  'platforms',
  'sites',
  'platformSites',
  'excludedDestinations',
  pitchStoryDialogCtrl
];

export default function (ngModule) {
  ngModule.controller('pitchStoryDialogCtrl', pitchStoryDialogCtrlArr);
}
